/**
 * Transforms the nearby cities data response into Things To Do Shelf Data
 * @param locationSlug current location slug
 * @param data nearby cities response data
 * @returns Things To Do Shelf Data
 */
export const transformIntoThingsToDoShelfData = (
    locationSlug: string,
    data: any,
) => {
    const {
        buckets,
        place: { name },
    } = data;

    if (!buckets || !buckets.length || !buckets[0].places) {
        return {
            tags: [],
            header: { placeName: '', url: '' },
        };
    }

    const tags: { placeName: string; linkUrl: string }[] = [];

    buckets[0].places.slice(0, 12).forEach((place: any) => {
        if (place.url) {
            tags.push({
                placeName: place.name,
                linkUrl: place.url
                    .replace('/d/', '/ttd/')
                    .replace('/events/', '/'),
            });
        }
    });

    const header = {
        placeName: name,
        url: `/ttd/${locationSlug}/`,
    };

    return {
        tags,
        header,
    };
};
